module.exports = __webpack_public_path__ + "img/kachel-VERLETZUNGEN_specialcarebox.236641e3.png";